import { render, staticRenderFns } from "./WrongAccess.vue?vue&type=template&id=32afd906&scoped=true"
import script from "./WrongAccess.vue?vue&type=script&lang=js"
export * from "./WrongAccess.vue?vue&type=script&lang=js"
import style0 from "./WrongAccess.vue?vue&type=style&index=0&id=32afd906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32afd906",
  null
  
)

export default component.exports